module.exports = __webpack_public_path__ + "static/media/save.5f3e5aac.svg";